import React from 'react';

import { Text } from '@rover/kibble/core';
import type { TextCommonProps } from '@rover/kibble/core/Text/Text.common';

import { getReviewTextSegments } from './utils/reviewHighlights';

export type Props = {
  text: string;
  /** Passages of `text` that matched the searcher's pets, emphasized in full. Plain text, not markup. */
  highlights?: string[] | null;
  size?: TextCommonProps['size'];
  textColor?: TextCommonProps['textColor'];
};

/**
 * Renders review text with its matched passages emphasized in place. It returns
 * bare text nodes, so it can sit inside whichever text block a card already uses.
 */
const HighlightedReviewText = ({
  text,
  highlights,
  size,
  textColor,
}: Props): React.ReactElement => (
  <>
    {getReviewTextSegments(text, highlights).map((segment, index) =>
      segment.isHighlighted ? (
        <Text
          // Segments are positional: two identical passages differ only by index.
          key={index}
          size={size}
          textColor={textColor}
          fontWeight="semibold"
          testID="review-highlight"
        >
          {segment.text}
        </Text>
      ) : (
        segment.text
      )
    )}
  </>
);

export default HighlightedReviewText;
